import React from "react"

import ImageGallery from "react-image-gallery"

import Contact from "../components/contact"
import Layout from "../components/layout"
import { products } from "../utils/products"

import SEO from "../components/seo"

class ProductPage extends React.Component {
  properties = {
    transitionDuration: 750,
    infinite: true,
    arrows: true,
  }

  render_link = product => (
    <a
      key={product.name}
      href={product.link}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className="btn westman"
    >
      {product.name}
    </a>
  )

  render_categories = main_product => {
    return main_product.categories.map(category => {
      let elements = [
        category.name ? (
          <h2 key={`category-header-${category.name}`}>{category.name}</h2>
        ) : null,
      ]

      category.products.map(product => elements.push(this.render_link(product)))

      return (
        <div key={`category-container-${category.name}`} className="category">
          {elements}
        </div>
      )
    })
  }

  render() {
    const product = products[this.props.product]

    return (
      <Layout>
        <SEO title={product.title} />

        <ImageGallery
          items={product.images}
          showPlayButton={true}
          showBullets={true}
          showThumbnails={false}
          showNav={false}
          showFullscreenButton={false}
          lazyload={true}
          autoPlay={true}
          slideInterval={7500}
        />

        <article className="text-section buttons">
          <div className="product-header">
            <h2 className="section__title mb">{`${product.title} products`}</h2>
          </div>

          {this.render_categories(product)}
        </article>

        <Contact product={product.title} />
      </Layout>
    )
  }
}

export default ProductPage
